export default __webpack_public_path__ + "static/media/jupiter2.a7b67e0d.png";